import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      const dest = location.state?.from?.pathname || "/admin";
      navigate(dest, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 bg-[#0A1628]">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="admin-login-brand" className="inline-flex items-center gap-4 mb-12 group">
          <img src="/brand/unexx-mark.png" alt="U-NEXX" className="h-16 w-auto object-contain" />
          <div className="leading-tight border-l border-white/15 pl-4">
            <div className="font-serif-display text-[#F3EFE4] text-lg tracking-wide">U-NEXX</div>
            <div className="text-[0.55rem] tracking-[0.32em] text-[#8FA3B8] uppercase whitespace-nowrap">Admin Console</div>
          </div>
        </Link>

        <div className="overline mb-4">Sign in</div>
        <h1 className="font-serif-display text-4xl md:text-5xl text-[#F3EFE4] mb-10 leading-[0.95]">
          Welcome back.
        </h1>

        <form onSubmit={handleSubmit} className="space-y-7" data-testid="admin-login-form">
          <div>
            <label className="field-label" htmlFor="al-email">Email</label>
            <input
              id="al-email"
              type="email"
              autoComplete="username"
              data-testid="admin-input-email"
              className="field-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="field-label" htmlFor="al-password">Password</label>
            <input
              id="al-password"
              type="password"
              autoComplete="current-password"
              data-testid="admin-input-password"
              className="field-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div data-testid="admin-login-error" className="text-sm text-red-400 border border-red-500/30 px-4 py-3">
              {error}
            </div>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={submitting}
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {submitting ? "Signing in…" : "Sign In"}
            {!submitting && <span className="btn-arrow">→</span>}
          </button>
        </form>

        <Link
          to="/"
          data-testid="admin-login-back"
          className="block mt-10 text-xs tracking-[0.3em] uppercase text-[#8FA3B8] hover:text-[#D4AF37] transition"
        >
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
